import { useEffect } from 'react';
import { useToast } from './ToastProvider';

const APP_VERSION = "1.0.1";

const VersionChecker = () => {
  const { addToast } = useToast();

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Fetch with a timestamp to bypass cache
        const response = await fetch(`/meta.json?t=${new Date().getTime()}`, {
          cache: 'no-cache'
        });
        
        if (!response.ok) return;
        
        const data = await response.json();
        
        if (data && data.version && data.version !== APP_VERSION) {
          addToast(
            "New update available! Click here to refresh and continue activity.", 
            "info", 
            60000,
            () => window.location.reload()
          );
          
          // Store in session storage that we found an update so we don't keep toast-ing
          sessionStorage.setItem('update_available', 'true');
        }
      } catch (error) {
        // Silently fail version check
      }
    };

    // Only check if we haven't already detected an update in this session
    if (sessionStorage.getItem('update_available') !== 'true') {
        let interval;
        const initialCheck = window.setTimeout(() => {
          checkVersion();
          interval = window.setInterval(checkVersion, 10 * 60 * 1000);
        }, 3000);
        return () => {
          window.clearTimeout(initialCheck);
          window.clearInterval(interval);
        };
    }
  }, [addToast]);

  return null;
};

export default VersionChecker;
